import React, { useEffect, useState } from "react";
import { Link, Link as LinkRRD } from "react-router-dom";

import {
  Breadcrumbs,
  Button,
  Card,
  FormControl,
  IconButton,
  InputBase,
  InputLabel,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Box, display, minWidth, Stack } from "@mui/system";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Helmet } from "react-helmet-async";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import SearchIcon from "@mui/icons-material/Search";

import LoadingUI from "../../comman/LoadingUI";
import { useNavigate } from "react-router-dom";
import NoDataFound from "../../comman/NoDataFound";
import SnackBarUI from "../../comman/SnackBarUI";
import Appbar from "../../components/Appbar";
import { dateFormatStartFun } from "../../helper/dateConverter";
import Body from "../../layout/Body";

import { allDeviceInfoAction } from "../../redux/toolkit/users/deviceInfo";
import { useStyles } from "../../theme/theme";
import { min } from "lodash";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={
        <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
      }
      aria-label="breadcrumb"
    >
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/"
      >
        Home
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/admin"
      >
        User
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/devices-info"
      >
        Device Info
      </Link>
    </Breadcrumbs>
    <Typography sx={{ color: "#5E6C8A" }} variant="h5">
      Device Info
    </Typography>
  </Stack>
);

const DeviceInfo = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const allDeviceInfo = useSelector((state) => state.allDeviceInfo);
  let { data, loading, total, message, status } = allDeviceInfo;

  const [pageState, setPageState] = useState({ page: 0, pageSize: 25 });
  const classes = useStyles();
  const [snack, setSnack] = useState(false);
  const [userId, setUserId] = useState("");
  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });

  const adminColumns = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      maxWidth: 50,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const { page, pageSize } = pageState;
        const serialNumber =
          page * pageSize + params?.api?.getRowIndex(params.row._id) + 1;
        return serialNumber;
      },
    },

    {
      field: "_id",
      headerName: "Visitor Id",
      filterable: false,
      flex: 1,
      maxWidth: 350,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "app_id",
      headerName: "App Id",
      filterable: false,
      flex: 1,
      maxWidth: 350,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "p_user_id",
      headerName: "P User Id",
      filterable: false,
      flex: 1,
      maxWidth: 400,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "user_id",
      headerName: "User Id",
      filterable: false,
      flex: 1,
      minWidth: 250,

      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.user_id}</Typography>;
      },
    },

    {
      field: "userEmail",
      headerName: "Email",
      filterable: false,
      flex: 1,
      maxWidth: 350,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.userEmail}</Typography>;
      },
    },

    {
      field: "UserFromSameDevice",
      headerName: "User From Same Device",
      flex: 1,
      minWidth: 350,
      minWidth: 250,
      justifyContent: "center",
      headerClassName: "super-app-theme--header",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <Button
            variant=""
            color="secondary"
            onClick={() => {
              console.log("Navigating to:", params?.row?._id);
              navigate(`/userFormSameDevice/${params?.row?._id}`);
            }}
            sx={{
              backgroundColor: "#2c79e6",
              color: "white",
              "&:hover": { backgroundColor: "#79a7e8" },
              textTransform: "capitalize",
              fontSize: "12px",
              alignItems: "center",
            }}
          >
            Get User
          </Button>
        );
      },
    },

    {
      field: "createdAt",
      headerName: "Created At",
      filterable: false,
      flex: 1,
      maxWidth: 350,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography>
            {moment(params?.row?.createdAt)
              .local()
              .format("DD-MM-YYYY,h:mm:ss a")}
          </Typography>
        );
      },
    },
  ];

  const dateWiseUser = () => {
    dispatch(
      allDeviceInfoAction({
        startDate: date?.startDate ? dateFormatStartFun(date?.startDate) : null,
        endDate: date?.endDate ? dateFormatStartFun(date?.endDate) : null,
        userId: userId ? userId : null,
        page: pageState.page,
        pageSize: pageState.pageSize,
      })
    );
  };

  const searchHandler = () => {
    dispatch(
      allDeviceInfoAction({
        page: pageState.page,
        pageSize: pageState.pageSize,
        userId: userId ? userId : null,
        startDate: date?.startDate ? dateFormatStartFun(date?.startDate) : null,
        endDate: date?.endDate ? dateFormatStartFun(date?.endDate) : null,
      })
    );
  };

  useEffect(() => {
    dispatch(
      allDeviceInfoAction({
        page: pageState.page,
        pageSize: pageState.pageSize,
        userId: userId ? userId : null,
        startDate: date?.startDate ? dateFormatStartFun(date?.startDate) : null,
        endDate: date?.endDate ? dateFormatStartFun(date?.endDate) : null,
      })
    );
  }, [pageState.page, pageState.pageSize]);

  return (
    <>
      <Helmet>
        <title>Real Opinion Admin | device info</title>
      </Helmet>
      <Appbar breadcrumb={breadcrumb} />

      <Body>
        <Stack
          sx={{ mt: 1 , mb:2}}
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          
        >
          <Stack direction={"row"} justifyContent={"space-between"}>
            <Paper
              component="form"
              sx={{
                p: "2px 4px",
                display: "flex",
                alignItems: "center",
                width: 400,
                backgroundColor: "transparent",
              }}
            >
              <InputBase
                sx={{ ml: 1, flex: 1 }}
                placeholder="search By UserId"
                inputProps={{
                  "aria-label": "search By Emails And UserId",
                }}
                onChange={(e) => setUserId(e.target.value)}
              />
              <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
                <SearchIcon onClick={searchHandler} />
              </IconButton>
            </Paper>
          </Stack>
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          //   alignItems="flex-start"
        >
          <Stack direction="row" spacing={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateTimePicker
                label="Min Data/Time"
                value={date?.startDate}
                maxDate={moment()}
                onChange={(newValue) => {
                  setDate({ ...date, startDate: newValue });
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateTimePicker
                label="Max Data/Time"
                value={date?.endDate}
                minDate={date?.startDate}
                maxDate={moment()}
                onChange={(newValue) => {
                  setDate({ ...date, endDate: newValue });
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            {date?.startDate && date?.endDate && (
              <Button variant="contained" onClick={dateWiseUser}>
                find data
              </Button>
            )}
          </Stack>
        </Stack>

        <Card sx={{ my: 2 }}>
          <Paper
            sx={{
              bgcolor: "#fff",
              "& .super-app-theme--header": {
                bgcolor: "#071D45",
                color: "#fff",
              },
            }}
            elevation={0}
          >
            <DataGrid
              className={classes.root}
              getRowHeight={() => "auto"}
              sx={{ border: 0 }}
              rows={data}
              autoHeight
              columns={adminColumns}
              getRowId={(row) => row._id}
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              pagination
              // pageSize={pageSize}
              // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[25, 50, 100]}
              disableColumnSelector
              loading={loading ? <LoadingUI /> : false}
              // loading={loading ? <Loader /> : false}
              components={{
                NoRowsOverlay: () => <NoDataFound />,
                // Toolbar: GridToolbar,
              }}
              rowCount={total}
              paginationModel={setPageState}
              page={pageState.page}
              pageSize={pageState.pageSize}
              paginationMode="server"
              onPageChange={(newPage) => {
                setPageState((old) => ({ ...old, page: newPage }));
              }}
              onPageSizeChange={(newPageSize) =>
                setPageState((old) => ({ ...old, pageSize: newPageSize }))
              }
            />
          </Paper>
        </Card>
      </Body>

      <SnackBarUI
        state={snack}
        setState={setSnack}
        status={status}
        message={message}
      />
    </>
  );
};

export default DeviceInfo;
